import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, CircularProgress, Grid, Button } from '@mui/material';
import CustomButton from '../subComponent/CustomButton';
import ClientHeaderComponent from '../subComponent/ClientHeaderComponent';
import '../data/styles.css';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    root: {
        '@media (max-width: 400px)': {
            '& strong': {
                fontSize: '1rem',
            },
            '& .MuiTypography-body1': {
                fontSize: '0.8rem',
            },
        },
    },
});
const dotStyle = {
    display: 'inline-block',
    width: '8px',
    height: '8px',
    margin: '0 2px',
    borderRadius: '50%',
    backgroundColor: '#fff',
    animation: 'dot-blink 0.5s infinite both',
};

const dotContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: "10px 30px",
};

const Paynow = () => {
    const classes = useStyles();
    const { id } = useParams(); // Get the id from the URL
    const [paymentData, setPaymentData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [loadingPayNow, setLoadingPayNow] = useState(false);

    useEffect(() => {
        const fetchPaymentData = async () => {
            try {
                const response = await fetch(`https://apiroutetapxtream.invtechnologies.in/get_payment_service_by_id/${id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    // console.log(data);
                    const datearray = [data];
                    // console.log(datearray.length);
                    // console.log(datearray[0]);
                    if (datearray && datearray.length > 0) {
                        setPaymentData(datearray[0]); // Assuming the API returns an array
                        localStorage.setItem("payid", datearray[0].genarate_id);
                    } else {
                        setError("No data found for this ID.");
                    }
                } else {
                    setError("Failed to fetch data.");
                }
            } catch (err) {
                console.error('Error fetching payment data:', err);
                setError("An error occurred while fetching data.");
            } finally {
                setLoading(false);
            }
        };

        fetchPaymentData();
    }, [id]);

    if (loading) {
        return (<Box sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh"
        }}>
            <CircularProgress />
        </Box>);
    }

    if (error) {
        return (
            <Box sx={{ p: 2 }}>
                <Typography color="error">{error}</Typography>
            </Box>
        );
    }

    const getTimeStamp = () => {
        return new Date().getTime();
    };

    const timestamp = getTimeStamp();

    const onPayNowClickHandle = async () => {
        // const baseUrl = window.location.href;
        const baseUrl = 'https://payments.invtechnologies.in/';

        const data = {
            id: paymentData.genarate_id,
            planname: paymentData.plan_months,
            amount: paymentData.amount,
            phone: paymentData.phone_no,
            email: paymentData.email,
            transactionid: `MT${timestamp}`,
            muid: `MUID${timestamp}`,
            url: baseUrl,
        };

        // console.log("subscribe data:", data);
        try {
            setLoadingPayNow(true);
            const response = await fetch('https://apiroutetapxtream.invtechnologies.in/makeorder', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });
            if (response.status != "200") {
                // console.log({ text: response.data ?? "error" });
                setLoadingPayNow(false);
                return;
            }
            // setLoadingPayNow(false);
            const responseData = await response.json();
            // console.log("API response:", responseData);

            const redirect = responseData.data?.instrumentResponse?.redirectInfo?.url;
            // const redirect = response.data.instrumentResponse.redirectInfo.url;

            if (redirect) {
                window.location.href = redirect;
            } else {
                console.error("Redirect URL not found in the response.");
            }
        } catch (error) {
            console.log(error);
            // alert({ text: error });
            setLoadingPayNow(false);
        }
    }

    const onSubmitBack = ()=>{
        if(paymentData.service_name === "Premium NFC Card" || paymentData.service_name === "Basic NFC Card"){
            window.location.href = "https://tapxtream.invtechnologies.in/nfc-display";
            // window.location.href = "http://localhost:3001/nfc-display";
        }
    }
    return (
        <Box sx={{ backgroundColor: "#0f172a", height: "100vh" }}>
            <ClientHeaderComponent />
            <Box sx={{ p: 2, color: "white", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Box sx={{ backgroundColor: "#020817", color: "white", width: "280px", borderRadius: "10px", p: 2 }}>
                    <Grid container spacing={2} p={1} className={classes.root}>
                        <Grid item xs={12}>
                            <Typography variant="h5" textAlign="center">Payment Details</Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography><strong>Name:</strong></Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="body1">{paymentData.user_name}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography><strong>Email:</strong></Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography sx={{ fontWeight: "bold", wordBreak: "break-word", overflowWrap: "break-word" }}>{paymentData.email}</Typography>
                            {/* <Typography variant="body1" >{paymentData.email}</Typography> */}
                        </Grid>
                        <Grid item xs={4}>
                            <Typography><strong>Phone:</strong></Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="body1">{paymentData.phone_no}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography><strong>Service:</strong></Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="body1">{paymentData.service_name}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography><strong>Duration:</strong></Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="body1">
                                {paymentData.plan_months === 0 ? "Lifetime" :
                                    paymentData.plan_months === 1 ? "1 Month" :
                                        `${paymentData.plan_months} Months`}
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography><strong>Amount:</strong></Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="body1">₹{paymentData.amount}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography><strong>Status:</strong></Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="body1">{paymentData.payment_status}</Typography>
                        </Grid>
                    </Grid>

                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", gap: "1rem" }}>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={() => onSubmitBack()}
                            sx={{ fontWeight: "bold" }}
                        >
                            Back
                        </Button>

                        <Button
                            variant="contained"
                            color={paymentData.payment_status === "Successful" ? "success" : "primary"}
                            fullWidth
                            onClick={() => onPayNowClickHandle()}
                            sx={{ fontWeight: "bold" }}
                            disabled={paymentData.payment_status === "Successful" || loadingPayNow}
                        >
                            {loadingPayNow  ? (
                                <Box sx={{ ...dotContainerStyle }}>
                                    <Box sx={{ ...dotStyle, animationDelay: '0s' }}></Box>
                                    <Box sx={{ ...dotStyle, animationDelay: '0.2s' }}></Box>
                                    <Box sx={{ ...dotStyle, animationDelay: '0.4s' }}></Box>
                                    <Box sx={{ ...dotStyle, animationDelay: '0.6s' }}></Box>
                                    <Box sx={{ ...dotStyle, animationDelay: '0.8s' }}></Box>
                                </Box>
                            ) : (
                                paymentData.payment_status === "Successful" ? "Success" : "Pay Now"
                            )}
                        </Button>
                    </Box>
                    {/* <Box display="flex" justifyContent="center" alignItems="center">
                        <div class="wrapper">
                            <button className="button"
                                onClick={() => onPayNowClickHandle()}
                                disabled={paymentData.payment_status === "Successful" || loadingPayNow}>
                                {
                                    paymentData.payment_status === "Successful" ?
                                        <div class="btndiv">
                                            <div class="scale rotate-4">S</div>
                                            <div class="scale rotate-2">u</div>
                                            <div class="scale rotate-1">c</div>
                                            <div class="scale rotate-3">c</div>
                                            <div class="scale rotate-4">e</div>
                                            <div class="scale rotate-2">s</div>
                                            <div class="scale rotate-1">s</div>
                                        </div>
                                        :
                                        <div>
                                            {loadingPayNow ? <Box
                                                sx={{
                                                    display: "inline-flex",
                                                    transition: "transform 0.3s ease",
                                                    "&:hover": {
                                                        transform: "scale(0.7)",
                                                    },
                                                }}
                                            >
                                                <CircularProgress sx={{ color: "rgba(37, 61, 29, 0.7)" }} />
                                            </Box> :
                                                <div class="btndiv">
                                                    <div class="scale rotate-4">P</div>
                                                    <div class="scale rotate-2">a</div>
                                                    <div class="scale rotate-1">y</div>
                                                    <div class="scale rotate-3">-</div>
                                                    <div class="scale rotate-4">N</div>
                                                    <div class="scale rotate-2">o</div>
                                                    <div class="scale rotate-1">w</div>
                                                </div>
                                            }</div>
                                }
                            </button>
                        </div>
                    </Box> */}
                    {/* <CustomButton
                        title="Pay Now"
                        loading={loadingPayNow}
                        onPressed={() => onPayNowClickHandle()}
                        sx={{ backgroundColor: "white", color: "black" }}
                        hoverColor="green"
                        // fullWidth
                        hoverTxtColor="white" /> */}
                </Box>
            </Box>
        </Box >
    );
};

export default Paynow;
